import { KeyValue } from '@/main/models/common';
import { ContactTypeDomain } from '@/main/models/request';

export enum ContactTypeTypes {
  GET_CONTACT_TYPE = '@contactType/GET_Contact_TYPE',
  SAVE_CONTACT_TYPE = '@contactType/SAVE_CONTACT_TYPE',
  RESET_REDUCER_CONTACT_TYPE = '@contactType/RESET_REDUCER_CONTACT_TYPE'
}

export interface ContactTypeState {
  readonly contactType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetContactType {
  type: typeof ContactTypeTypes.GET_CONTACT_TYPE;
  payload: {
    request?: ContactTypeDomain;
  };
}

export interface SaveContactType {
  type: typeof ContactTypeTypes.SAVE_CONTACT_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerContactType {
  type: typeof ContactTypeTypes.RESET_REDUCER_CONTACT_TYPE;
}

export type ContactTypeActionTypes =
  | GetContactType
  | SaveContactType
  | ResetReducerContactType;
